import React from 'react';

const RedirectPage = function () {
  return <div>このリンクは無効です。リンクに間違いがないかを確認してください。</div>;
};

export default RedirectPage;
